import { render } from "./FormBellerLoperView.vue?vue&type=template&id=238a500a"
import script from "./FormBellerLoperView.vue?vue&type=script&lang=js"
export * from "./FormBellerLoperView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__